import * as N from "react";
import { g as H, c as T } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { s as x, b as V, c as W, u as X } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { u as G } from "./useFormControl-C9UMlaFq.mjs";
import { g as J } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as b } from "./jsx-runtime-3tyXYecC.mjs";
import { B as Y } from "./ButtonBase-BIvHZGlt.mjs";
import { u as Z } from "./useControlled-ZIJRsfP8.mjs";
import { c as z } from "./tss-DN0acMKN.mjs";
import { m as K } from "./memoTheme-BzXKG_-k.mjs";
import { f as _ } from "./formControlState-vgaj2ksH.mjs";
import { u as ee } from "./useSlot-CRj3SG25.mjs";
import { T as O } from "./Typography-DfkimCSn.mjs";
function oe(e) {
  return H("PrivateSwitchBase", e);
}
J("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const te = (e) => {
  const {
    classes: o,
    checked: r,
    disabled: t,
    edge: l
  } = e, d = {
    root: ["root", r && "checked", t && "disabled", l && `edge${z(l)}`],
    input: ["input"]
  };
  return W(d, oe, o);
}, re = x(Y)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: o
    }) => e === "start" && o.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: o
    }) => e === "end" && o.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), se = x("input", {
  shouldForwardProp: V
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), ke = /* @__PURE__ */ N.forwardRef(function(o, r) {
  const {
    autoFocus: t,
    checked: l,
    checkedIcon: d,
    className: h,
    defaultChecked: p,
    disabled: S,
    disableFocusRipple: P = !1,
    edge: U = !1,
    icon: R,
    id: B,
    inputProps: E,
    inputRef: M,
    name: v,
    onBlur: k,
    onChange: w,
    onFocus: L,
    readOnly: q,
    required: u = !1,
    tabIndex: F,
    type: i,
    value: g,
    ...$
  } = o, [m, C] = Z({
    controlled: l,
    default: !!p,
    name: "SwitchBase",
    state: "checked"
  }), s = G(), j = (n) => {
    L && L(n), s && s.onFocus && s.onFocus(n);
  }, f = (n) => {
    k && k(n), s && s.onBlur && s.onBlur(n);
  }, c = (n) => {
    if (n.nativeEvent.defaultPrevented)
      return;
    const A = n.target.checked;
    C(A), w && w(n, A);
  };
  let a = S;
  s && typeof a > "u" && (a = s.disabled);
  const Q = i === "checkbox" || i === "radio", I = {
    ...o,
    checked: m,
    disabled: a,
    disableFocusRipple: P,
    edge: U
  }, D = te(I);
  return /* @__PURE__ */ b.jsxs(re, {
    component: "span",
    className: T(D.root, h),
    centerRipple: !0,
    focusRipple: !P,
    disabled: a,
    tabIndex: null,
    role: void 0,
    onFocus: j,
    onBlur: f,
    ownerState: I,
    ref: r,
    ...$,
    children: [/* @__PURE__ */ b.jsx(se, {
      autoFocus: t,
      checked: l,
      defaultChecked: p,
      className: D.input,
      disabled: a,
      id: Q ? B : void 0,
      name: v,
      onChange: c,
      readOnly: q,
      ref: M,
      required: u,
      ownerState: I,
      tabIndex: F,
      type: i,
      ...i === "checkbox" && g === void 0 ? {} : {
        value: g
      },
      ...E
    }), m ? d : R]
  });
});
function ae(e) {
  return H("MuiFormControlLabel", e);
}
const y = J("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), le = (e) => {
  const {
    classes: o,
    disabled: r,
    labelPlacement: t,
    error: l,
    required: d
  } = e, h = {
    root: ["root", r && "disabled", `labelPlacement${z(t)}`, l && "error", d && "required"],
    label: ["label", r && "disabled"],
    asterisk: ["asterisk", l && "error"]
  };
  return W(h, ae, o);
}, ne = x("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${y.label}`]: o.label
    }, o.root, o[`labelPlacement${z(r.labelPlacement)}`]];
  }
})(K(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${y.disabled}`]: {
    cursor: "default"
  },
  [`& .${y.label}`]: {
    [`&.${y.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: o
    }) => o === "start" || o === "top" || o === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), ie = x("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, o) => o.asterisk
})(K(({
  theme: e
}) => ({
  [`&.${y.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), we = /* @__PURE__ */ N.forwardRef(function(o, r) {
  const t = X({
    props: o,
    name: "MuiFormControlLabel"
  }), {
    checked: l,
    className: d,
    componentsProps: h = {},
    control: p,
    disabled: S,
    disableTypography: P,
    inputRef: U,
    label: R,
    labelPlacement: B = "end",
    name: E,
    onChange: M,
    required: v,
    slots: k = {},
    slotProps: w = {},
    value: L,
    ...q
  } = t, u = G(), F = S ?? p.props.disabled ?? (u == null ? void 0 : u.disabled), i = v ?? p.props.required, g = {
    disabled: F,
    required: i
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((a) => {
    typeof p.props[a] > "u" && typeof t[a] < "u" && (g[a] = t[a]);
  });
  const $ = _({
    props: t,
    muiFormControl: u,
    states: ["error"]
  }), m = {
    ...t,
    disabled: F,
    labelPlacement: B,
    required: i,
    error: $.error
  }, C = le(m), s = {
    slots: k,
    slotProps: {
      ...h,
      ...w
    }
  }, [j, f] = ee("typography", {
    elementType: O,
    externalForwardedProps: s,
    ownerState: m
  });
  let c = R;
  return c != null && c.type !== O && !P && (c = /* @__PURE__ */ b.jsx(j, {
    component: "span",
    ...f,
    className: T(C.label, f == null ? void 0 : f.className),
    children: c
  })), /* @__PURE__ */ b.jsxs(ne, {
    className: T(C.root, d),
    ownerState: m,
    ref: r,
    ...q,
    children: [/* @__PURE__ */ N.cloneElement(p, g), i ? /* @__PURE__ */ b.jsxs("div", {
      children: [c, /* @__PURE__ */ b.jsxs(ie, {
        ownerState: m,
        "aria-hidden": !0,
        className: C.asterisk,
        children: [" ", "*"]
      })]
    }) : c]
  });
});
export {
  we as F,
  ke as S
};
//# sourceMappingURL=FormControlLabel-BtrCkdi3.mjs.map
